$(document).ready(function(){

	// -- AVAILAIBLE ON SHOPS WEBPAGES ONLY --

	if ($('body').hasClass('type--shops')) {

		mapboxgl.accessToken = 'pk.eyJ1IjoiZXZlcnl0aGluZ2lzZnVuIiwiYSI6IkVkalZJRUkifQ.i_Taxju9f5wO9aUyOF7Gyg';

		var shops = {
			"type": "FeatureCollection",
			"features": []
		};
		var bounds = new mapboxgl.LngLatBounds();
		var boundsSettings = {
		  padding: {top: 30, bottom: 30, left: 30, right: 30}
		};

		// -- Create shops data --
		if ($('main').hasClass('shops__details')) {
			var lang = $('html').attr('lang');
			var searchShopsUrl = window.location.origin + '/' + lang + '/search/shops';

			$.ajax({
			  type: 'get',
			  url: searchShopsUrl,
			  dataType: 'html',
			  success: function(response, statut){
			    console.log('success');
			    var articleItem = $(response).find('.article--shop');
			    createFeature(articleItem);
					addAllShops();
					addCurrentShop();
			  },
			  error: function(response, statut, error){
			    console.log('error');
			  }
			});

		} else {
	    var articleItem = $('.article--shop');
			createFeature(articleItem);
		}


		// -- Init mapbox --
		var map = new mapboxgl.Map({
			container: 'interactiveMap',
			style: "mapbox://styles/mapbox/streets-v10",
			zoom: 7.2,
			center: [6.05505,49.81566]
		});


		// -- Load events -- 
		map.on('load', function() {
			
			if (!$('main').hasClass('shops__details')) {
				addAllShops();
				addGeocoder();
	
				// -- Fit map to markers --
				map.fitBounds(bounds, boundsSettings);

			}

	  });




		// -- Functions --

		function createFeature(articleItem){
			articleItem.each(function(key, value) {
				var title = $(value).find('.article__title').text();
				var categories = $(value).find('.article__categories')[0].children;
				var lng = $(value).find('.article__address').attr('data-lng');
				var lat = $(value).find('.article__address').attr('data-lat');
				var address = $(value).find('.article__address').text();

				for (var i = 0; i < categories.length; i++) {
					var cat = $(categories[i]).find('.article__cat').attr('data-cat');
					var feature = {
						"type": "Feature",
						"properties": {
				      "title": title,
				      "cat": cat,
				      "address": address
						},
						"geometry": {
							"type": "Point",
							"coordinates": [lng,lat]
						}
					};
					shops.features.push(feature);
			    bounds.extend(feature.geometry.coordinates);
				}
			});
		}


		function createMarkers(classname, feature){
		  // -- Remove previous active marker  --
		  $('.marker').remove();
		  
		  // -- Init marker --
		  var el = document.createElement('div');
		  el.className = classname;

		  // -- Add marker --
		  new mapboxgl.Marker(el)
		  .setLngLat(feature.geometry.coordinates)
		  .addTo(map);

		  // -- Add popup event --
		  new mapboxgl.Marker(el)
		  .setLngLat(feature.geometry.coordinates)
		  .setPopup(new mapboxgl.Popup({ offset: 25 })
		  .setHTML('<h4>' + feature.properties.title + '</h4><p>' + feature.properties.address + '</p>'))
		  .addTo(map);
		}


		function addAllShops(){
		
			// -- Add marker image --
			map.loadImage('./assets/img/icon-marker.png', function(error, image) {
				if (error) throw error;
				map.addImage('cat', image);
			});


			// -- Add a GeoJSON source --
			map.addSource("shops", {
				"type": "geojson",
				"data": shops
			});


			shops.features.forEach(function(feature) {

				var cat = feature.properties.cat;
				var layerID = 'poi-' + cat;
			  if (!map.getLayer(layerID)) {
					
					// -- Add Layers by cat title --
			  	map.addLayer({
			  		"id": layerID,
			  		"type": "symbol",
			  		"source": "shops",
			  		"layout": {
			  			"icon-image": "cat",
			  			"icon-size": 0.33,
			  			"icon-allow-overlap": true,
			  			"text-allow-overlap": true
			  		},
			  		"filter": ["==", "cat", cat]
			  	});

			    // -- Update the visibility of the layer --
					var input = $('#poi-' + cat);
			    input.on('change', function(e) {
			    	map.setLayoutProperty(layerID, 'visibility',
			    		e.target.checked ? 'visible' : 'none');
			    });

			  }

			  // -- Add markers & popup --
			  createMarkers('popup-event', feature);

			});
		}


		function addGeocoder(){
		
			// -- Add geocoder input --
			var geocoder = new MapboxGeocoder({
		    accessToken: mapboxgl.accessToken,
		    flyTo: false
			});
			$('#geocoder').append(geocoder.onAdd(map));

			
			map.addSource('localisation', {
			  type: 'geojson',
			  data: {
			    type: 'FeatureCollection',
			    features: []
			  }
			});

			map.addLayer({
			  id: 'point',
			  source: 'localisation',
			  type: 'circle',
			  paint: {
			    'circle-radius': 10,
			    'circle-color': '#007cbf',
			    'circle-stroke-width': 3,
			    'circle-stroke-color': '#fff'
			  }
			});

			geocoder.on('result', function(ev) {
				// -- Get filtered shops --
				var filteredShops = getFilteredShops();

				// -- Add point on location --
				var targetPoint = ev.result.geometry;
				map.getSource('localisation').setData(targetPoint);

				// -- Add nearest shop's marker & popup --
				var nearest = turf.nearestPoint(targetPoint, filteredShops);
			  createMarkers('marker', nearest);

				// -- Fly to nearest shop --
				map.flyTo({
					center: nearest.geometry.coordinates,
					zoom: 12,
				});
			});

			// -- Remove marker on location --
			$('.geocoder-icon-close').on('click', function(){
				$('.marker').remove();
			});


		}


		function addCurrentShop(){
			var articleTitle = $('.shops__details .article__header h1').text();
			for (var i = 0; i < shops.features.length; i++) {
				if (shops.features[i].properties.title == articleTitle) {

					// -- Add active marker & popup --
				  createMarkers('marker', shops.features[i]);
					
				  // -- Fly to active marker --
					map.flyTo({
						center: shops.features[i].geometry.coordinates,
						zoom: 12,
					});
					return;		
				}
			}
		}

		function getFilteredShops(){
			var selected = [];
			$('.filter-group input:checked').each(function() {
				var cat = $(this).attr('name');
				cat = cat.replace('poi-', '');
		    selected.push(cat);
			});
			var filteredShops = {
				"type": "FeatureCollection",
				"features": []
			};
			shops.features.forEach(function(feature) {
				currentCat = feature.properties.cat;
				if ($.inArray( currentCat, selected ) != -1) {
		    	filteredShops.features.push(feature);
				}
			});
			// console.log(filteredShops);
			return filteredShops;
		}

	}

});